<app-nav-bar></app-nav-bar>
<div class="nav_content-container">
  <div class="nav_content">
    <div class="nav_content-image">
      <img height="40px" src="{{ courseImage }}" alt="{{ courseImageName }}" />
    </div>

    <div class="nav_chapter">
      <div
        [routerLink]="['/start-lesson', currentLesson.CourseId, 'sample']"
        class="chapter-title hover"
      >
        {{ courseTitle }}
      </div>
      <div class="day-info">Day {{ routeParams.currentDay }}</div>
    </div>
  </div>
</div>

<div class="page_for_readplan">
  <a
    href="javascript:void(0)"
    (click)="getPreviousLesson()"
    id="previous-arrow"
    class="img-placeholder icon-56 chapter-arrow-previous"
    title="Previous chapter"
  ></a>

  <div class="body_of_read_lesson message">
    <div class="message">
      <div class="message_header">
        <h3 class="message_title">Message</h3>
        <audio
          *ngIf="currentLesson.CourseLessonAudio"
          controls
          src="{{ currentLesson.CourseLessonAudio }}"
        ></audio>
      </div>

      <video
        *ngIf="currentLesson.CourseLessonVideo"
        class="message_video"
        controls
        src="{{ currentLesson.CourseLessonVideo }}"
      ></video>
    </div>
    <article
      class="message_article"
      [innerHTML]="safeHTML(currentLesson.CourseLessonDescription)"
    ></article>
  </div>

  <a
    href="javascript:void(0)"
    (click)="getNextLesson()"
    id="next-arrow"
    class="img-placeholder icon-56 chapter-arrow-next"
    title="Next chapter"
  ></a>
</div>
